import React from "react";
import { EvaluationCard, EvaluationFooter } from "./components";
import EvaluationSlider from "../../../Components/Student/EvaluationSlider";
import { NotesToggleInput } from "./EvaluationComponents";

const QuestionItem = ({
  q,
  idx,
  total,
  evaluations,
  handleEvaluationChange,
}) => {
  const ev = evaluations.find((e) => e.questionId === q.questionId);
  const scoreVal = ev ? ev.score : 0;
  const feedbackVal = ev ? ev.feedback : "";

  return (
    <div className="d-flex flex-column gap-3 text-end" dir="rtl">
      {total > 1 && (
        <div className="fw-bold text-muted mb-1" style={{ fontSize: "14px" }}>
          السؤال {idx + 1} من {total}
        </div>
      )}

      <div
        className="p-3 border rounded-3 bg-white"
        style={{ borderColor: "#e2e8f0" }}
      >
        <div className="fw-bold text-dark" style={{ fontSize: "15px" }}>
          {q.question.questionText}
        </div>
      </div>

      <div
        className="p-3 border rounded-3"
        style={{
          borderColor: "#f1f5f9",
          backgroundColor: "#f8fafc",
        }}
      >
        <div
          className="text-muted"
          style={{
            fontSize: "15px",
            whiteSpace: "pre-line",
          }}
        >
          {q.answerText}
        </div>
      </div>

      <div
        className="p-4 border rounded-3 bg-white mt-2"
        style={{ borderColor: "#e2e8f0" }}
      >
        <EvaluationSlider
          score={scoreVal}
          feedback={feedbackVal}
          isEditable={true}
          onScoreChange={(val) =>
            handleEvaluationChange(q.questionId, "score", val)
          }
          onFeedbackChange={(val) =>
            handleEvaluationChange(q.questionId, "feedback", val)
          }
          title="تقييم المعلم (درجة)"
          showDescriptionOnly={true}
        />
      </div>

      <div className="mt-2">
        <NotesToggleInput
          notes={feedbackVal}
          setNotes={(val) =>
            handleEvaluationChange(q.questionId, "feedback", val)
          }
          label="ملاحظات السؤال:"
          placeholder="اضف ملاحظاتك هنا..."
        />
      </div>
    </div>
  );
};

const QuestionsStep = ({
  answeredOpenQuestions,
  evaluations,
  handleEvaluationChange,
  handleSave,
  handleExit,
  isSaving,
}) => {
  return (
    <div
      className="mx-auto"
      style={{ maxWidth: "860px", width: "100%", direction: "rtl", paddingBottom: "100px" }}
    >
      <EvaluationCard className="mb-4">
        <h4
          className="text-center mb-4 fw-bold text-dark"
          style={{ fontSize: "22px" }}
        >
          أسئلة النقد والتذوق والإبداع
        </h4>

        {answeredOpenQuestions.length === 0 ? (
          <div className="text-center text-muted p-4">
            لا توجد أسئلة مفتوحة تمت الإجابة عليها.
          </div>
        ) : (
          <div className="d-flex flex-column gap-5">
            {answeredOpenQuestions.map((q, idx) => (
              <QuestionItem
                key={q.questionId || idx}
                q={q}
                idx={idx}
                total={answeredOpenQuestions.length}
                evaluations={evaluations}
                handleEvaluationChange={handleEvaluationChange}
              />
            ))}
          </div>
        )}
      </EvaluationCard>

      <EvaluationFooter
        primaryText="الانتقال الى النتائج"
        secondaryText="الرجوع"
        onPrimaryClick={handleSave}
        onSecondaryClick={handleExit}
        showSecondary={true}
        isSaving={isSaving}
      />
    </div>
  );
};

export default QuestionsStep;
